import { ScheduleSummaryTone } from "@/common/helpers/scheduleSummaryLabel";

export type SummaryTone = ScheduleSummaryTone;

export const summaryToneVibes: Record<
  SummaryTone,
  "text-neutral-quiet" | "text-warning-moderate" | "text-danger-intense"
> = {
  neutral: "text-neutral-quiet",
  warning: "text-warning-moderate",
  danger: "text-danger-intense",
};
